module.exports = __webpack_public_path__ + "img/logo3.a236a932.png";